import { render, staticRenderFns } from "./ContractRemark.vue?vue&type=template&id=18f94b3e&scoped=true"
import script from "./ContractRemark.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractRemark.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ContractRemark.vue?vue&type=style&index=0&id=18f94b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f94b3e",
  null
  
)

export default component.exports